<ng-template
  #cdkConnectedOverlayTemp
  cdkConnectedOverlay
  [cdkConnectedOverlayPush]="overlayPush"
  [cdkConnectedOverlayOrigin]="overlayOrigin"
  [cdkConnectedOverlayOpen]="isOpened"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayBackdropClass]="backDropClass()"
  [cdkConnectedOverlayPositions]="newPosition"
  (detach)="connectedOverlayDetach()"
  (backdropClick)="onBackdropClick()"
>
  <sd-theme-wrapper [brand]="brand">
    <div
      role="dialog"
      aria-labelledby="modalTitle"
      class="c__modal"
      [ngClass]="'c--' + modalType + ' ' + modalCustomClass"
      [id]="modalCustomId"
      [attr.data-position]="modalPosition"
      [@.disabled]="disabledAnimation"
      [@isOpenedChanged]="setTranslateAxis(modalPosition)"
    >
      @if (focus) {
        <div cdkTrapFocusAutoCapture cdkTrapFocus>
          <ng-container *ngTemplateOutlet="content" />
        </div>
      }

      @if (!focus) {
        <div>
          <ng-container *ngTemplateOutlet="content" />
        </div>
      }
    </div>
  </sd-theme-wrapper>
</ng-template>

<ng-template #content>
  <ng-content select="[sd-modal-close]" />
  <ng-content />
</ng-template>
